'use client';

import Button from '@/app/components/ui/Button';
import { useWhatsAppLink } from '@/app/hooks/useWhatsAppLink';

export default function HubGovernancaSection() {
  const getWhatsAppLink = useWhatsAppLink();

  const handleDiagnostico = () => {
    const link = getWhatsAppLink();
    window.open(link, '_blank');
  };

  const YOUTUBE_VIDEO_ID = '4eSaVCtZ4n4';

  return (
    <section id="hub-governanca" className="w-full bg-[#02020c] relative py-12 lg:py-24 px-4 overflow-hidden">
      {/* Background Image Overlay */}
      <img
        src="/images/img_group_94.png"
        alt=""
        className="absolute inset-0 w-full h-full object-cover z-0 opacity-20"
      />

      <div className="w-full max-w-7xl mx-auto relative z-10 flex flex-col items-center gap-10 lg:gap-16">
        {/* Header */}
        <div className="flex flex-col items-center gap-4 sm:gap-6 w-full max-w-3xl text-center">
          <h2
            className="text-[30px] sm:text-[45px] lg:text-[60px] font-normal leading-tight"
            style={{ fontFamily: 'Raleway' }}
          >
            <span className="bg-gradient-to-b from-[#f7faff] to-[#9eb5dc] bg-clip-text text-transparent">
              Hub de{' '}
            </span>
            <span className="text-[#ffffff] font-semibold italic">Governança</span>
          </h2>

          <p
            className="text-[15px] sm:text-[19px] lg:text-[22px] font-normal leading-relaxed text-[#b7c3d7]"
            style={{ fontFamily: 'Raleway' }}
          >
            A IA lê as conversas dos seus vendedores, qualifica leads automaticamente e move os cards no funil —{' '}
            <span className="font-semibold italic text-white">sem que ninguém precise atualizar o CRM manualmente</span>.
          </p>
        </div>

        {/* Video Container */}
        <div className="w-full max-w-4xl">
          <div className="relative bg-[#0d121f] rounded-[24px] overflow-hidden shadow-2xl border border-[#ffffff0f]">
            {/* Browser Top Bar */}
            <div className="absolute top-0 left-0 w-full h-10 sm:h-12 bg-[#1a1f2e]/90 backdrop-blur-md border-b border-white/5 flex items-center px-4 z-20">
              <div className="flex items-center gap-1.5">
                <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full bg-[#ff5f57]"></div>
                <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full bg-[#febc2e]"></div>
                <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full bg-[#28c840]"></div>
              </div>
            </div>

            {/* YouTube Embed */}
            <div className="w-full aspect-video pt-10 sm:pt-12 bg-[#050505]">
              <iframe
                src={`https://www.youtube.com/embed/${YOUTUBE_VIDEO_ID}?rel=0&modestbranding=1&controls=0`}
                title="Hub de Governança — Evolutta"
                loading="lazy"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                className="w-full h-full"
              />
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="w-full flex justify-center">
          <Button
            onClick={handleDiagnostico}
            text_font_size="text-lg"
            text_font_family="Raleway"
            text_font_weight="font-normal"
            text_line_height="leading-base"
            text_text_align="center"
            text_color="text-primary-background"
            fill_background_color="bg-button-primary"
            border_border_radius="rounded-xl"
            padding="py-[14px] px-[34px] pr-[56px]"
            className="italic flex items-center gap-[10px] hover:opacity-90 transition-opacity duration-200 group"
          >
            <span className="group-hover:text-[#02020c] transition-colors duration-200">
              QUERO IMPLEMENTAR NO MEU NEGÓCIO
            </span>
            <img
              src="/images/img_group_84.svg"
              alt="Arrow"
              className="w-[22px] h-[22px] group-hover:invert transition-all duration-200"
            />
          </Button>
        </div>
      </div>
    </section>
  );
}
